/* Páginas de coleção Navita (sections/navita-colecao.liquid): painel de filtros, ordem, "Ver mais",
   "Adicionar ao carrinho" nos cartões e "Ler mais". Sem este ficheiro tudo continua a funcionar como links e formulários normais. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.navitaColecaoPronto) {
  window.navitaColecaoPronto = true;

  const raiz = () => document.querySelector('[data-nc]');

  function abrir(grupo) {
    const r = raiz();
    if (!r) return;
    const painel = r.querySelector('.nc-painel');
    const fundo = r.querySelector('.nc-painel-fundo');
    painel.hidden = false;
    fundo.hidden = false;
    requestAnimationFrame(() => r.classList.add('nc--aberto'));
    document.documentElement.classList.add('nc-sem-scroll');
    r.querySelectorAll('.nc-grupo').forEach((d) => d.classList.remove('is-destaque'));
    if (grupo) {
      const d = [...r.querySelectorAll('.nc-grupo')].find((x) => x.dataset.ncGrupo === grupo);
      if (d) {
        d.open = true;
        d.classList.add('is-destaque');
        d.scrollIntoView({ block: 'start' });
      }
    }
    painel.querySelector('[data-nc-fechar]')?.focus({ preventScroll: true });
  }

  function fechar() {
    const r = raiz();
    if (!r || !r.classList.contains('nc--aberto')) return;
    r.classList.remove('nc--aberto');
    document.documentElement.classList.remove('nc-sem-scroll');
    setTimeout(() => {
      r.querySelector('.nc-painel').hidden = true;
      r.querySelector('.nc-painel-fundo').hidden = true;
    }, 300);
  }

  async function verMais(link) {
    const r = raiz();
    link.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(link.href, location.href);
      url.searchParams.set('section_id', r.dataset.section);
      // em texto: uma app da loja substitui o fetch e só aceita endereços em texto
      const html = await fetch(url.toString()).then((x) => {
        if (!x.ok) throw new Error(x.status);
        return x.text();
      });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grelha = r.querySelector('[data-nc-grelha]');
      doc.querySelectorAll('[data-nc-grelha] > .nc-item').forEach((li) => grelha.append(li));
      const novo = doc.querySelector('[data-nc-mais]');
      if (novo) r.querySelector('[data-nc-mais]').replaceWith(novo);
    } catch (e) {
      location.href = link.href; // sem JS / erro: vai para a página seguinte
    }
  }

  async function juntar(form) {
    const botao = form.querySelector('button');
    const texto = botao.textContent;
    botao.disabled = true;
    try {
      const id = Number(form.querySelector('[name="id"]').value);
      const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });
      if (!r.ok) throw new Error(r.status);
      // o carrinho lateral do tema volta a desenhar-se e abre-se sozinho (action "add")
      const promessa = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: promessa.promise }));
      promessa.resolve({ detail: {} });
      botao.textContent = '✓';
      setTimeout(() => { botao.textContent = texto; botao.disabled = false; }, 1600);
    } catch (e) {
      form.submit();
    }
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-nc-abrir]');
    if (a) { abrir(a.getAttribute('data-nc-abrir')); return; }
    if (e.target.closest('[data-nc-fechar]')) { fechar(); return; }
    const mais = e.target.closest('[data-nc-mais-link]');
    if (mais) { e.preventDefault(); verMais(mais); return; }
    const ler = e.target.closest('[data-nc-ler]');
    if (ler) {
      const caixa = ler.closest('[data-nc-sobre]');
      const aberto = caixa.classList.toggle('is-aberto');
      ler.setAttribute('aria-expanded', aberto);
      ler.textContent = aberto ? ler.dataset.menos : ler.dataset.mais;
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') fechar(); });

  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.matches('[data-nc-juntar]')) { e.preventDefault(); juntar(f); return; }
    if (f.matches('.nc-painel__form')) {
      // preços vazios não vão para o endereço
      f.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
    }
  });

  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-nc-ordem]');
    if (s) { s.form?.requestSubmit(); return; }
    const radio = e.target.closest('[data-nc-ordem-radio]');
    if (radio) {
      const sel = raiz()?.querySelector('[data-nc-ordem]');
      if (sel) sel.value = radio.value;
    }
  });
}
